import React from "react";

function Feature() {
  return (
    <section id="features" className="features section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Why Choose Us</h2>
        <p>Strong Presence Across Multiple Business Sectors</p>
      </div>

      <div className="container">
        <div className="row gy-4">

          {/* Hotels & Hospitality */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={100}>
            <div className="feature-box orange">
              <i className="bi bi-house-door" />
              <h4>Hotels & Hospitality</h4>
              <p>Quality dining and hospitality services serving pilgrims in Makkah.</p>
            </div>
          </div>

          {/* Catering Services */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={200}>
            <div className="feature-box green">
              <i className="bi bi-egg-fried" />
              <h4>Catering Services</h4>
              <p>Multi-cuisine catering solutions for Umrah groups, Hajj pilgrims, events.</p>
            </div>
          </div>

          {/* Food Store */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={300}>
            <div className="feature-box blue">
              <i className="bi bi-shop" />
              <h4>Makkah Food Store</h4>
              <p>Wholesale and retail supply of essential food items, groceries, frozen products.</p>
            </div>
          </div>

          {/* Building Materials */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={400}>
            <div className="feature-box red">
              <i className="bi bi-hammer" />
              <h4>Building Materials</h4>
              <p>Complete range of building, electrical, plumbing, and hardware materials.</p>
            </div>
          </div>

          {/* MPC Plastics */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={500}>
            <div className="feature-box purple">
              <i className="bi bi-basket" />
              <h4>MPC Plastics</h4>
              <p>Plastic household items, food containers, disposables, cleaning tools, cosmetics.</p>
            </div>
          </div>

          {/* Logistics */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={600}>
            <div className="feature-box teal">
              <i className="bi bi-truck" />
              <h4>Logistics & Supply Chain</h4>
              <p>Reliable shipping, air cargo, road transport, and warehousing services.</p>
            </div>
          </div>

          {/* Trading */}
          <div className="col-xl-3 col-md-6" data-aos="zoom-in" data-aos-delay={700}>
            <div className="feature-box yellow">
              <i className="bi bi-globe" />
              <h4>IT Solutions</h4>
              <p>We deliver innovative IT solutions, system integration, and digital support services that help businesses enhance productivity, security, and technological growth.</p>
            </div>
          </div>

        </div>
      </div>

      {/* CSS for pastel colors */}
      <style jsx>{`
        .feature-box {
          height: 100%;
          padding: 28px 22px;
          border-radius: 16px;
          text-align: center;
          color: #1d1b1bff;
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .feature-box:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
        }

        .feature-box i {
          font-size: 42px;
          margin-bottom: 14px;
          display: inline-block;
        }

        .feature-box h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 8px;
        }

        .feature-box p {
          font-size: 0.9rem;
          opacity: 0.85;
          margin: 0;
        }

        /* Pastel gradient colors */
        .orange { background: linear-gradient(135deg, #f8cbafff, #f8cbafff); }
        .green { background: linear-gradient(135deg, #c7f8c7ff, #c7f8c7ff); }
        .blue { background: linear-gradient(135deg, #a9dafaff, #a9dafaff); }
        .red { background: linear-gradient(135deg, #f8a5a5ff, #f8a5a5ff); }
        .purple { background: linear-gradient(135deg, #d5bafaff, #d5bafaff); }
        .teal { background: linear-gradient(135deg, #c2f8f8ff, #c2f8f8ff); }
        .yellow { background: linear-gradient(135deg, #fae9b9ff, #fae9b9ff); }
      `}</style>
    </section>
  );
}

export default Feature;
